import FeedBack from 'views/feedBack/FeedBack.container';

export default FeedBack;